import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { datricApi } from '../../../services/api/datric.api';
import { ApiKeyUsage, ClientStat, IndicatorStat, Overview, TimelinePoint } from '../../../models/dashboard.model';
import { toastService } from '../../../services/toast.service';

export interface DashboardState {
	overview: Overview | null;
	byClient: ClientStat[];
	byIndicator: IndicatorStat[];
	timeline: TimelinePoint[];
	apiKeyUsage: ApiKeyUsage[];
	loading: boolean;
}

const initialState: DashboardState = {
	overview: null,
	byClient: [],
	byIndicator: [],
	timeline: [],
	apiKeyUsage: [],
	loading: false
};

export const fetchDashboard = createAsyncThunk(
	'dashboard/fetch',
	async (payload: { from?: string; to?: string; includeStaff?: boolean }, { rejectWithValue }) => {
		try {
			const { from, to, includeStaff } = payload;
			const [overview, byClient, byIndicator, timeline, apiKeyUsage] = await Promise.all([
				datricApi.dashboard.overview(from, to, includeStaff),
				datricApi.dashboard.byClient(from, to, includeStaff),
				datricApi.dashboard.byIndicator(from, to, includeStaff),
				datricApi.dashboard.timeline(from, to, includeStaff),
				datricApi.dashboard.apiKeyUsage(from, to, includeStaff)
			]);
			return { overview, byClient, byIndicator, timeline, apiKeyUsage };
		} catch (e: any) {
			toastService.error(typeof e === 'string' ? e : 'Falha ao carregar dashboard');
			return rejectWithValue(e);
		}
	}
);

export const dashboardSlice = createSlice({
	name: 'dashboard',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchDashboard.pending, state => {
			state.loading = true;
		});
		builder.addCase(fetchDashboard.fulfilled, (state, action) => {
			state.loading = false;
			state.overview = action.payload.overview;
			state.byClient = action.payload.byClient;
			state.byIndicator = action.payload.byIndicator;
			state.timeline = action.payload.timeline;
			state.apiKeyUsage = action.payload.apiKeyUsage;
		});
		builder.addCase(fetchDashboard.rejected, state => {
			state.loading = false;
		});
	}
});
